<ng-container *ngIf="vm$ | async as vm">
  <div class="wd-container">

    <div class="showing-box">
      <div class="move move-back" (click)="onChangeDate(MoveType.Back)">
        <i class="fa fa-chevron-left"></i>
      </div>

      <div class="date">
        {{$safeNavigationMigration(vm?.date) | dateTimeFormat:$safeNavigationMigration(vm?.timezone):$safeNavigationMigration(vm?.dateFormat)}}
      </div>

      <div class="move move-next" (click)="onChangeDate(MoveType.Forward)">
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>


    <div class="today-pick">
      <a (click)="onChangeDate(MoveType.Today)">Today</a>
    </div>
    <div class="picker">
      <luxon-calendar [styleIcon]="styleIconCalendar" [showInput]="false" [showIcon]="true" [showZone]="false" [formControl]="selectedDate" appendTo="body"></luxon-calendar>
    </div>

  </div>

</ng-container>